import React from 'react';
import { ClearIndicatorProps } from 'react-select';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import styles from '../Select.module.scss';

function ClearIndicator(props: ClearIndicatorProps): React.ReactElement {
  const {
    innerProps: { ref, onMouseDown, onTouchEnd, ...restInnerProps },
  } = props;

  const handleMouseDown: React.MouseEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    event.stopPropagation();
    onMouseDown?.(event as unknown as React.MouseEvent<HTMLDivElement>);
  };

  const handleTouchEnd: React.TouchEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    event.stopPropagation();
    onTouchEnd?.(event as unknown as React.TouchEvent<HTMLDivElement>);
  };

  const handleKeyDown: React.KeyboardEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    event.stopPropagation();
    onMouseDown?.({
      ...event,
      button: 0,
      type: 'mousedown',
      preventDefault: () => event.preventDefault(),
      stopPropagation: () => event.stopPropagation(),
    } as unknown as React.MouseEvent<HTMLDivElement>);
  };

  return (
    <button
      {...(restInnerProps as React.ButtonHTMLAttributes<HTMLButtonElement>)}
      ref={ref as unknown as React.Ref<HTMLButtonElement>}
      type="button"
      onMouseDown={handleMouseDown}
      onTouchEnd={handleTouchEnd}
      onKeyDown={handleKeyDown}
      className={styles.clearIconWrap}
    >
      <MaterialIcon icon="cancel" className={styles.clearIndicator} />
    </button>
  );
}

export default ClearIndicator;
